import { useStore } from "@/context/Store";

export const BrandSeal = ({ className = "" }) => {
  const { settings: s } = useStore();
  if (!s?.store) return null;
  return (
    <div className={`brand-seal ${className}`} data-testid="brand-seal" role="img" aria-label={`Bijouterie ${s.store.name}`}>
      <span className="brand-seal-line" /><div className="brand-seal-mark"><i>Bijouterie</i><b>{s.store.name}</b></div><span className="brand-seal-line is-r" />
    </div>
  );
};
